/** Print voucher HTML already fetched with auth (avoids 401 on raw API URL). */
export function printVoucherHtml(html: string): void {
  const content = html?.trim();
  if (!content) return;

  const iframe = document.createElement('iframe');
  iframe.setAttribute('aria-hidden', 'true');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  document.body.appendChild(iframe);

  const frameWindow = iframe.contentWindow;
  const frameDoc = iframe.contentDocument ?? frameWindow?.document;
  if (!frameDoc || !frameWindow) {
    document.body.removeChild(iframe);
    return;
  }

  frameDoc.open();
  frameDoc.write(content);
  frameDoc.close();

  const cleanup = () => {
    if (iframe.parentNode) {
      iframe.parentNode.removeChild(iframe);
    }
  };

  const triggerPrint = () => {
    frameWindow.focus();
    frameWindow.print();
    window.setTimeout(cleanup, 1000);
  };

  if (frameDoc.readyState === 'complete') {
    window.setTimeout(triggerPrint, 100);
  } else {
    iframe.onload = () => window.setTimeout(triggerPrint, 100);
  }
}
